import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "we9gplbt",
    dataset: "production"
})